import React from 'react'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import Smartview from 'widgets/smartviews/Smartview'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import CreateSpecialDaySmartview from 'widgets/smartviews/shifts/CreateSpecialDaySmartview'
import ButtonWrap from '../../../ui/layouts/ButtonWrap'
import Button from 'ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import SpecialDaysSmartviewHeader from 'widgets/smartviews/shifts/SpecialDaysSmartviewHeader'
import SpecialDay from 'widgets/special-days/SpecialDay'

function SpecialDaysSmartview (props) {
  const {
    date
  } = props

  return (
    <Smartview header={<SpecialDaysSmartviewHeader date={date} />}>
      <ValueToCollection name='special_days'>
        <div className='space-y-4'>
          <ForEachModel>
            <SpecialDay />
          </ForEachModel>
        </div>
      </ValueToCollection>
      <SmartviewContentSeparator />

      <ButtonWrap>
        <MountSmartviewOnClick smartview={<CreateSpecialDaySmartview date={date} />} replace={false}>
          <Button fullWidth>
            <Translation name='special_days.create' />
          </Button>
        </MountSmartviewOnClick>
      </ButtonWrap>
    </Smartview>
  )
}

export default SpecialDaysSmartview
